export default __webpack_public_path__ + "static/media/loginBg.fdb33ca9.svg";